import {
  CREATE_PART,
  CREATE_PART_SUCCESS,
  DELETE_PART,
  DELETE_PART_SUCCESS,
  GET_PART,
  GET_PART_SUCCESS,
  GET_PARTS,
  GET_PARTS_SUCCESS,
  UPDATE_PART,
  UPDATE_PART_SUCCESS,
  UPDATE_PARTS_PAGINATION
} from "../constants/Parts";

export const getParts = (page, perPage = 10, search = "", filters = "") => {
  return {
    type: GET_PARTS,
    page,
    perPage,
    search,
    filters,
  }
}

export const getPartsSuccess = (parts, total, from, to) => {
  return {
    type: GET_PARTS_SUCCESS,
    parts,
    from,
    to,
    total
  }
}

export const createPart = (data, history) => {
  return {
    type: CREATE_PART,
    data,
    history
  }
}

export const createPartSuccess = (part) => {
  return {
    type: CREATE_PART_SUCCESS,
    part
  }
}

export const getPart = (id) => {
  return {
    type: GET_PART,
    id
  }
}

export const getPartSuccess = (part) => {
  return {
    type: GET_PART_SUCCESS,
    part
  }
}

export const updatePart = (id, part, history) => {
  return {
    type: UPDATE_PART,
    id,
    part,
    history,
  }
}

export const updatePartSuccess = (part) => {
  return {
    type: UPDATE_PART_SUCCESS,
    part
  }
}

export const deletePart = (part_id, history) => {
  return {
    type: DELETE_PART,
    part_id,
    history
  }
}

export const deletePartSuccess = () => {
  return {
    type: DELETE_PART_SUCCESS,
  }
}

export const updatePartsPagination = (page, perPage = 10, search = "") => {
  return {
    type: UPDATE_PARTS_PAGINATION,
    perPage,
    search,
    page
  }
}